"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

const shimmerClasses = "bg-[linear-gradient(110deg,#404040,35%,#fff,50%,#404040,75%,#404040)] bg-[length:200%_100%]";
const shimmerAnimation = {
  initial: { backgroundPosition: "200% 0" },
  animate: { backgroundPosition: "-200% 0" },
  transition: {
    repeat: Infinity,
    duration: 2,
    ease: "linear" as const
  }
};

type ShiningTextProps = {
  text: string;
  className?: string;
};

export function ShiningText({ text, className }: ShiningTextProps) {
  return (
    <motion.h1
      className={cn(shimmerClasses, "bg-clip-text text-base font-normal text-transparent", className)}
      {...shimmerAnimation}
    >
      {text}
    </motion.h1>
  );
}

type ShimmerOverlayProps = {
  className?: string;
  style?: React.CSSProperties;
};

export function ShimmerOverlay({ className, style }: ShimmerOverlayProps) {
  return <motion.div className={cn(shimmerClasses, className)} style={style} {...shimmerAnimation} />;
}
